module.exports = __webpack_public_path__ + "img/logo-purple.ad77c5dd.png";